/*
 * @ts-ignore
 * @ts-nocheck
 */
import supportsWebP from 'supports-webp';
import { appWSM2021Config } from './config';
import { Loader } from '@powerplay/loading-system';
import { Initializer } from '@powerplay/initializer';
import { LoadingStatsTypes } from '@powerplay/stats-system';
import { SettingsTypes } from '@powerplay/settings';
import { PlayerRace, PlayerSex, RequestLogTypes } from '@powerplay/request-system';
import { modes, MobileDetector, displayManager, checkWGLAvailability, errorManager, checkInstancedArraysAvailability, FirstTweenCheck, CustomEvents } from '@powerplay/common';
import { requestManager, game, gameStats, translations, settings, corePhasesManager, trainingManager, playersManager, tutorialManager, audioManager, cameraManager, CorePhases } from '.';
/**
 * Hlavna trieda pre CORE
 */
export class MainCore {
    /**
     * Konstruktor
     * @param dataForCore - Data pre CORE
     * @param translatesReplacements - Vymeny textor pre preklady
     * @param assetsData - Data assetov z discipliny
     * @param onUpdateAimSensitivity - callback pre update aim sensitivity
     * @param onUpdateOneFinger - callback pre oneFinger
     */
    constructor(dataForCore, translatesReplacements, assetsData, onUpdateAimSensitivity, onUpdateOneFinger) {
        this.onUpdateAimSensitivity = onUpdateAimSensitivity;
        this.onUpdateOneFinger = onUpdateOneFinger;
        /** Sysytem na iniciatizovanie prveho tweenu */
        this.firstTweenCheck = new FirstTweenCheck();
        /** Kontrola inicializacie veci */
        this.initializer = new Initializer();
        /** Interval pre kontrolu konca inicializacie */
        this.intervalEndOfInit = 0;
        /** Ci ide o lokalny environment  */
        this.isLocalEnv = false;
        /** Ci uz bol nastaveny loader ready */
        this.setLoaderReady = false;
        /** ci sme chytili error custom event */
        this.errorEventCatched = false;
        /**
         * Nastavenie nastaveni :D
         */
        this.setSettings = () => {
            if (modes.isExternalApp) {
                const settingsDefault = {
                    [SettingsTypes.quality]: {
                        value: 8,
                        name: SettingsTypes.quality
                    },
                    [SettingsTypes.sounds]: {
                        value: 1,
                        name: SettingsTypes.sounds
                    },
                    [SettingsTypes.qualityAuto]: {
                        value: 1,
                        name: SettingsTypes.qualityAuto
                    },
                    [SettingsTypes.isLeft]: {
                        value: 0,
                        name: SettingsTypes.isLeft
                    },
                    [SettingsTypes.controlsType]: {
                        value: 2,
                        name: SettingsTypes.controlsType
                    },
                    [SettingsTypes.aimSensitivity]: {
                        value: 3,
                        name: SettingsTypes.aimSensitivity
                    },
                    [SettingsTypes.vibrations]: {
                        value: 1,
                        name: SettingsTypes.vibrations
                    },
                    [SettingsTypes.oneFinger]: {
                        value: 0,
                        name: SettingsTypes.oneFinger
                    }
                };
                const settingsString = window.localStorage.getItem('settingsMinigameExternalApp');
                let settingsStringNew = settingsDefault;
                if (settingsString) {
                    settingsStringNew = JSON.parse(settingsString);
                    // ak mame default pre controlsType 0, musime to hodit na default hodnotu, aby neboli problemy nikdy v downhille
                    // v inych disciplinach nevyzuivame momentalne, tak nam to je jedno, ci tam bude 0 alebo 2
                    if (settingsStringNew[SettingsTypes.controlsType].value === 0) {
                        settingsStringNew[SettingsTypes.controlsType].value = 2;
                        window.localStorage.setItem('settingsMinigameExternalApp', JSON.stringify(settingsStringNew));
                    }
                }
                else {
                    window.localStorage.setItem('settingsMinigameExternalApp', JSON.stringify(settingsStringNew));
                }
                settings.setValues(settingsStringNew);
                this.initializer.requestSettings.setReady();
            }
            else {
                // request posielame, ak neriesime localStorage
                requestManager.sendSettingsRequest((data) => {
                    settings.setValues(data);
                    this.initializer.requestSettings.setReady();
                });
            }
        };
        /**
         * Zistenie kompatibility roznych veci
         */
        this.checkCompatibility = async () => {
            // Instanced arrays check
            game.batchingManager.available = checkInstancedArraysAvailability();
            this.removeModelsInBatching();
            // Odstranenie treningovych veci
            this.removeTrainingModels();
            // Ci je dostupne WebP
            const webpSupported = await supportsWebP;
            console.log('AVAILABILITY', `WebP ${webpSupported}`, `Instanced arrays ${game.batchingManager.available}`);
            this.loader = new Loader(webpSupported, game.renderManager.renderer);
            this.loader.init(this.assetsData.models, this.assetsData.textures, this.assetsData.audio);
            this.initializer.compatibility.setReady();
        };
        /**
         * Callback pre nacitanie vsetkych assetov
         */
        this.onLoadedAllAssets = () => {
            // nastavime asset pre hru
            game.set3DObjectsAfterLoaded(this.loader.assetsLoaders.a3d.objects3DData, this.loader.assetsLoaders.textures.texturesData);
            this.initializer.assetsCore.setReady();
            // debug
            this.setUpDebug();
        };
        /**
         * Kontrola konca inicializacie
         */
        this.checkEndOfInitialization = () => {
            if (this.loader.readyToLoad && !this.setLoaderReady) {
                this.setLoaderReady = true;
                this.initializer.loaders.setReady();
            }
            if (this.initializer.isReadyToLoadAssets()) {
                gameStats.setLoadingStats(LoadingStatsTypes.partBeforeLoader);
                this.loader.loadAll(this.onLoadedAllAssets, audioManager.add);
            }
            if (this.initializer.isReadyToCreateAssets()) {
                gameStats.setLoadingStats(LoadingStatsTypes.partLoadingAssets);
                this.dataForCore.callbacks.createAssets();
                this.initializer.assets.setReady();
            }
            if (this.initializer.isReadyToEndInitialization() && this.firstTweenCheck.checked) {
                window.clearInterval(this.intervalEndOfInit);
                this.onInitEnd();
            }
        };
        this.afterLoadingDone = () => {
            gameStats.setLoadingStats(LoadingStatsTypes.endTime);
            window.dispatchEvent(new CustomEvent(CustomEvents.gameStart));
            // posleme informaciu na FE, ze sme dokoncili a pri board games a podobnych eventoch stopnu timer na kontrolu
            if (modes.isExternalApp && window.parent)
                window.parent.postMessage({ minigameLoaded: true }, '*');
            corePhasesManager.startFirstPhase();
        };
        /**
         * Odstranenie objektov z pamate na konci
         */
        this.disposeAllObjects = () => {
            // TODO: toto dat na konci
            try {
                audioManager.stopAllAudio();
                audioManager.unloadAll();
                // musime najskor pauznut veci a az potom davat dispose, aby to vsetko spravilo
                game.paused = true;
                window.setTimeout(game.disposeAll, 50);
            }
            catch (e) {
                /*
                 * neriesime nic, lebo aj tak budeme redirectovat
                 * throw Error('Issues in element dispose happened with')
                 */
            }
        };
        this.dataForCore = dataForCore;
        if (assetsData)
            this.assetsData = assetsData;
        // musime robit cim skor, aby sme mali dobre cisla, ale zaroven potrebujeme mod na to
        displayManager.setUp(requestManager.appRedirect);
        requestManager.setCallbackDisposeObjects(this.disposeAllObjects);
        gameStats.setLoadingStats(LoadingStatsTypes.partFirstInit);
        // preklady skusime dat skor, aby sme mali aj skor hint
        requestManager.sendTranslationsRequest((data) => {
            translations.setTranslations(data, translatesReplacements);
            this.initializer.requestTranslations.setReady();
            this.initializer.ui.setReady();
        });
        // musime spustit init request a az potom riesit dalsie veci
        requestManager.sendInitRequest((data) => {
            gameStats.setLoadingStats(LoadingStatsTypes.partInitRequest);
            const dataFromRequest = data;
            // v pripade appky WSM 2021 prepisujeme data
            const appWSM2021Data = appWSM2021Config.data;
            if (appWSM2021Data) {
                // pridavame nasho hraca ako prveho a dalsi su superi
                dataFromRequest.players = [
                    dataFromRequest.players[0],
                    ...appWSM2021Data.players
                ];
                dataFromRequest.specialData = appWSM2021Data.specialData;
            }
            // trening
            if (dataFromRequest.trainingData) {
                trainingManager.setUpFromData(dataFromRequest.trainingData);
            }
            // specialData su data pre konkretnu disciplinu, kt si obhospodaruje dana disciplina
            if (dataFromRequest.specialData) {
                this.dataForCore.callbacks.setSpecialDataFromInitRequest?.(dataFromRequest.specialData);
            }
            // prejdeme si hracov a upravime im nejake veci kvoli event badgeom - neskor to bude riesene na BE
            dataFromRequest.players.forEach((playerInfo) => {
                if (playerInfo.badges === undefined)
                    return;
                const badges = ['gold', 'silver', 'bronze'];
                const usedBadgesIndexes = [];
                const usedBadges = [];
                playerInfo.badges?.event_badges?.forEach((badge, index) => {
                    usedBadges.push(badge.type);
                    usedBadgesIndexes[badges.indexOf(badge.type)] = index;
                });
                const newBadges = [];
                for (let i = 0; i < 3; i += 1) {
                    if (!usedBadges.includes(badges[i])) {
                        newBadges[i] = {
                            top: false,
                            value: 0,
                            type: badges[i]
                        };
                    }
                    else {
                        newBadges[i] = playerInfo.badges.event_badges[usedBadgesIndexes[i]];
                    }
                }
                playerInfo.badges.event_badges = newBadges;
            });
            corePhasesManager.init(this.dataForCore.numberOfAttempts, dataFromRequest.firstInstructions === 1 || modes.isTutorial(true));
            playersManager.players = dataFromRequest.players;
            this.initializer.requestInit.setReady();
            // pokracujeme dalej a ideme zistit poziadavky
            this.checkRequirements();
            const dataToSend = { match_id: dataFromRequest.match_id };
            window.parent.postMessage(dataToSend, '*');
        }, trainingManager.retry);
        // hint cross musime dat cim skor - TODO
        /*
         *  requestManager.hintCrossRequest(() => {
         *
         *  // TODO: ukazat cross / hint
         *
         *  });
         */
        // zacneme spustat prvy tween
        this.firstTweenCheck.start();
    }
    /**
     * Nastavenie ci ide o lokalne prostredie
     * @param isLocalEnv - True, ak ide o lokalne prostredie
     */
    setIsLocalEnv(isLocalEnv) {
        this.isLocalEnv = isLocalEnv;
    }
    checkRequirements() {
        // ci je dostupne WebGL
        const webGLAvailable = checkWGLAvailability();
        console.log(`REQUIREMENTS WebGL ${webGLAvailable}`);
        if (webGLAvailable) {
            game.create();
            console.log('Game3D CREATED');
            audioManager.create();
            settings.init(audioManager.updateEnabled, game.updateQuality, game.updateIsLeft, this.onUpdateAimSensitivity, game.updateVibrations, this.onUpdateOneFinger);
            window.dispatchEvent(new CustomEvent(CustomEvents.readyForDisciplineInit));
        }
        else {
            throw new Error(errorManager.showBox('WEBGL not supported'));
        }
    }
    /**
     * Nastavenie dat pre pohlavie
     * @param sex - Pohlavie
     * @param data - data na zmenu
     */
    setSexData(sex, data) {
        if (!data.genderActive)
            return;
        if (sex === undefined)
            throw new Error(errorManager.showBox('sex not defined'));
        // zmenime verziu ak treba
        if (sex === PlayerSex.female)
            data.version = data.femaleVersion;
        data.dir += `${sex}/`;
    }
    /**
     * Uprava dat pre modely
     * @param playerInfo - Hracove info
     * @param opponentsIds - Superove id
     */
    editModelsData(playerInfo, opponentsIds) {
        // rovno vyhodime ignorovane
        this.assetsData.models = this.getLoaderDataWithoutIgnored(this.assetsData.models);
        const opponentOppositeSex = this.opponentDiffSex(playerInfo, opponentsIds);
        const models = this.assetsData.models;
        for (const [key, value] of Object.entries(models)) {
            // ci mame stiahnut pre supera iny model a to bude iba, ak sa nezhoduje pohlavie
            if (value.opponentCheck && opponentOppositeSex !== playerInfo.sex) {
                const keyOpponent = `${key}_opponent`;
                this.assetsData.models[keyOpponent] = { ...models[key] };
                this.setSexData(opponentOppositeSex, models[keyOpponent]);
            }
            this.setSexData(playerInfo.sex, models[key]);
        }
    }
    /**
     * Vrati ine pohlavie, ak niektory opponent nema rovnake ako hrac
     * @param playerInfo - Hracove info
     * @param opponentsIds - Superove id
     * @returns pohlavie protihraca
     */
    opponentDiffSex(playerInfo, opponentsIds) {
        const playerSex = playerInfo.sex;
        if (playerSex === undefined)
            throw new Error(errorManager.showBox('sex not defined'));
        for (let i = 0; i < opponentsIds.length; i += 1) {
            const id = opponentsIds[i];
            const opponentSex = playersManager.getPlayerById(id)?.sex;
            if (opponentSex === undefined) {
                throw new Error(errorManager.showBox(`${id}sex not defined`));
            }
            if (playerSex !== opponentSex) {
                return opponentSex;
            }
        }
        return playerSex;
    }
    /**
     * Uprava dat pre textury
     * @param playerInfo - Hracove info
     * @param opponentsIds - Superove id
     * @param raceSexNotUsed - pole spojenia pohlavia a rasy, ktore sa nepouzivaju
     */
    editTexturesData(playerInfo, opponentsIds, ignoredNames) {
        // nie vzdy musia byt superi definovani
        const opponentsActive = opponentsIds.length > 0;
        // rovno vyhodime ignorovane
        this.assetsData.textures = this.getLoaderDataWithoutIgnored(this.assetsData.textures, opponentsActive, ignoredNames);
        const textures = this.assetsData.textures;
        for (const [key, value] of Object.entries(textures)) {
            let opponentInfo;
            if (value.opponent) {
                let opponentIndex = Number(key.split(/(\d+)/)[1]) - 1;
                if (Number.isNaN(opponentIndex))
                    opponentIndex = 0;
                opponentInfo = playersManager.getPlayerById(opponentsIds[opponentIndex]);
            }
            const info = value.opponent && (opponentInfo !== undefined) ? opponentInfo : playerInfo;
            this.setSexData(info?.sex, textures[key]);
        }
    }
    /**
     * Uprava dat pre textury
     * @param racePrefix - prefix pre nazov suboru pre rasu
     * @param opponentsIds - Superove id
     */
    editMaterialsData(racePrefix = '', opponentsIds) {
        const materials = this.dataForCore.materials;
        for (const [_key, value] of Object.entries(materials)) {
            if (value.playerIndex !== undefined) {
                const playerInfo = value.playerIndex === 0 ?
                    playersManager.getPlayer() :
                    playersManager.getPlayerById(opponentsIds[value.playerIndex - 1]);
                const sex = playerInfo?.sex ?? PlayerSex.male;
                const race = playerInfo?.race ?? PlayerRace.white;
                value.secondTextureName = `${sex}/${racePrefix}${race}`;
            }
        }
    }
    /**
     * Uprava dat pre zvuky
     * @param playerInfo - Hracove info
     */
    editAudioData(playerInfo) {
        const newAudio = [];
        for (const value of Object.values(this.assetsData.audio)) {
            if (value.sex === undefined || value.sex === playerInfo.sex) {
                newAudio.push(value);
            }
        }
        this.assetsData.audio = newAudio;
    }
    /**
     * Prvotne inicializovanie
     * @param assetsData - Data assetov z discipliny
     * @param materials - Materialy po uprave
     * @param meshesCastShadows - Meshe, ktore budu vrhat tiene
     * @param batching - Data pre batching
     * @param ignoredTexturesNames - ignorovane mena textur
     * @param racePrefix - prefix pre nazov suboru pre rasu
     */
    init(assetsData, materials, meshesCastShadows, batching, opponentsIds = [], ignoredTexturesNames = [], racePrefix = '') {
        if (assetsData)
            this.assetsData = assetsData;
        if (materials)
            this.dataForCore.materials = materials;
        if (meshesCastShadows)
            this.dataForCore.meshesCastShadows = meshesCastShadows;
        if (batching)
            this.dataForCore.batching = batching;
        // poriesime nejake veci podla pohlavia a rasy
        console.log(opponentsIds[0], playersManager);
        const playerInfo = playersManager.getPlayer();
        // upravime vsetky data pre assety, aby sa vsetky kombinacie pohlavi a ras spravne dali
        this.editModelsData(playerInfo, opponentsIds);
        this.editTexturesData(playerInfo, opponentsIds, ignoredTexturesNames);
        this.editMaterialsData(racePrefix, opponentsIds);
        this.editAudioData(playerInfo);
        this.makeStartRequests();
        game.init(this.checkCompatibility, this.dataForCore);
        // kontrola konca inicializacie
        this.intervalEndOfInit = window.setInterval(this.checkEndOfInitialization, 100);
        if (modes.isTutorial()) {
            tutorialManager.listen(() => {
                if (game.paused)
                    game.resumeGame();
            });
        }
    }
    /**
     * Nastavenia kamerovych dat pre konkretnu fazu
     * @param phase - Faza
     * @param phaseCameraSettings - Nastavenia kamier vo faze
     */
    setCameraDataForOnePhase(phase, phaseCameraSettings) {
        if (!phaseCameraSettings)
            return;
        // 0 sa nastavuje napr pre trening, kde sa nepouziva intro2 kamera
        corePhasesManager.setPhaseDuration(phase, phaseCameraSettings.duration ?? 0);
        if (phaseCameraSettings.notSkippableFrames !== undefined) {
            corePhasesManager.setPhaseNotSkippableFrames(phase, phaseCameraSettings.notSkippableFrames);
        }
    }
    /**
     * Nastavenie tweenovych nastaveni pre dany stav kamery a dlzky faz
     * @param tweenSettingsForCameraStates - Objekt nastaveni kamier pre vsetky stavy
     */
    setTweenSettingsForStates(tweenSettingsForCameraStates) {
        cameraManager.setTweenSettingsForStates(tweenSettingsForCameraStates);
        // dlzka intro faz pojde automaticky a nemusi sa nastavovat cez speci premennu
        this.setCameraDataForOnePhase(CorePhases.intro, tweenSettingsForCameraStates.intro);
        this.setCameraDataForOnePhase(CorePhases.intro2, tweenSettingsForCameraStates.intro2);
    }
    /**
     * Spustenie pociatocnych requestov
     */
    makeStartRequests() {
        this.setSettings();
        // poslanie requestu pre ulozenie dat z startu minihry
        const dataStart = {
            mobile: MobileDetector.getDeviceTypeBasic(),
            device: MobileDetector.getDeviceTypeAdvanced(),
            user_agent: navigator.userAgent,
            device_width: displayManager.width,
            device_height: displayManager.height,
            device_pixel_ratio: window.devicePixelRatio
        };
        requestManager.sendLogRequest(RequestLogTypes.start, dataStart);
    }
    /**
     * Metoda na odstranenie treningovych prvkov pocas loadingu
     */
    removeTrainingModels() {
        if (modes.isTrainingMode())
            return;
        const newModels = {};
        if (this.assetsData.models) {
            for (const [key, value] of Object.entries(this.assetsData.models)) {
                if (!value.isTrainingModel)
                    newModels[key] = value;
            }
        }
        this.assetsData.models = newModels;
    }
    /**
     * ziskame modely okrem ignorovanych
     * @param allModels - vsetky modely ktore chceme prefiltrovat
     * @param opponentsActive - ci su dostupni superi
     * @param ignoredAssetsNames - nazvy assetov, ktore maju byt ignorovane
     * @returns - modely bez ignorovanych
     */
    getLoaderDataWithoutIgnored(allModels, opponentsActive = false, ignoredAssetsNames = []) {
        const models = {};
        for (const [key, value] of Object.entries(allModels)) {
            if (value.ignoreInModes?.includes(modes.mode) ||
                (!opponentsActive && value.opponent) ||
                ignoredAssetsNames.includes(key)) {
                console.log(`ignoring file ${key}`);
                continue;
            }
            models[key] = value;
        }
        return models;
    }
    /**
     * odstranenie modelov ktore sa batchuju z nacitania
     */
    removeModelsInBatching() {
        if (!game.batchingManager.available)
            return;
        const newModels = {};
        if (this.assetsData.models) {
            for (const [key, value] of Object.entries(this.assetsData.models)) {
                if (!value.useIfBatchingDisabled)
                    newModels[key] = value;
            }
        }
        this.assetsData.models = newModels;
    }
    /**
     * puts singletons into window object
     */
    setUpDebug() {
        if (!this.isLocalEnv)
            return;
        const debug = {
            requestManager,
            audioManager,
            modes,
            game,
            corePhasesManager,
            playersManager,
            displayManager
        };
        // eslint-disable-next-line
        window.debugCore = debug;
    }
    /**
     * Spravenie veci na konci inicializacie
     */
    onInitEnd() {
        settings.updateAllOnStart();
        this.dataForCore.callbacks.beforeGameStart();
        game.batchingManager.batch(game.scene);
        gameStats.setLoadingStats(LoadingStatsTypes.partSecondInit);
        game.start();
        window.addEventListener(CustomEvents.errorOccured, () => {
            this.errorEventCatched = true;
        });
        window.addEventListener(CustomEvents.firstUpdateDone, () => {
            console.log('first update done, ', this.errorEventCatched ? 'bol error' : 'ideme na update params');
            if (this.errorEventCatched)
                return;
            requestManager.sendUpdateParamsRequest(this.afterLoadingDone);
        });
    }
}
//# sourceMappingURL=MainCore.js.map